<template>
  <div class="date-info">
    <span class="star">*</span>
    {{ this.info }}
    <span v-if="date.month"><span class="month">{{ this.date.month }}</span></span>
    <span v-if="date.year"><span class="year">{{this.date.year }}</span></span>
  </div>
</template>

<script>
export default {
  name: 'FtaBottomDateInfo',
  props: {
    info: {
      type: String,
      default: ''
    },
    date: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>

<style scoped lang="less">
.date-info {
  padding-right: 25px;
  text-align: right !important;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  color: #000000;
  letter-spacing: -0.32px;
  font-weight: 400;

  .year,.month {
    color: #3897FF;
  }

  .star {
    color: #000000;
  }
}
</style>
